module.exports = __webpack_public_path__ + "img/DW365-221.296cf7e0.jpg";